module.exports = __webpack_public_path__ + "static/media/swipe.5acaf4a8.svg";